import './closest';



// WEBPACK FOOTER //
// ./client/src/core/polyfills/dom/index.js